import _toConsumableArray from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _slicedToArray from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _regeneratorRuntime from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.array.concat.js";
import { rawDataDownload } from '@/store/function/common/rawDataDownload';
import { isDateAfterToday } from '@/utils/datetime';

import { DateTime } from 'luxon';
import { mapState, mapActions } from 'vuex';
export default {
  name: 'RawDataDownload',
  data: function data() {
    return {
      selectDate: DateTime.local().setZone('Asia/Taipei').toFormat('yyyy-MM-dd'),
      loadingData: false,
      searchInput: '',
      allCheckbox: 'unSelected',
      selected: [],
      selectOptions: []
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState(['factoryInfo'])), {}, {
    filteredFactoryInfo: function filteredFactoryInfo() {
      return this.factoryInfo.filter(function (item) {
        return !item.isDemoSite;
      });
    }
  }),
  watch: {
    selected: function selected() {
      this.allCheckbox = this.selected.length === this.selectOptions.length ? 'selected' : 'unSelected';
    }
  },
  methods: _objectSpread(_objectSpread({}, mapActions(['asyncInfo'])), {}, {
    isDateAfterToday: isDateAfterToday,
    download: function download() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _this$selected;
        var dataDownload;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (_this.searchInput) {
                  _context.next = 2;
                  break;
                }
                return _context.abrupt("return", _this.$swal('請輸入案場'));
              case 2:
                if (_this.selectDate) {
                  _context.next = 4;
                  break;
                }
                return _context.abrupt("return", _this.$swal('請選擇日期'));
              case 4:
                if ((_this$selected = _this.selected) !== null && _this$selected !== void 0 && _this$selected.length) {
                  _context.next = 6;
                  break;
                }
                return _context.abrupt("return", _this.$swal('請選擇下載項目'));
              case 6:
                _this.loadingData = true;
                _context.next = 9;
                return rawDataDownload(_this.searchInput, _this.selectDate, _this.selected);
              case 9:
                dataDownload = _context.sent;
                if (!dataDownload) {
                  _this.$swal('所選項目尚無資料');
                }
                _this.loadingData = false;
              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    toggleSelectAll: function toggleSelectAll() {
      this.selected = this.allCheckbox === 'selected' ? this.selectOptions : [];
    },
    handleInputChange: function handleInputChange() {
      var _selectedFactoryData$;
      if (!this.searchInput) {
        this.allCheckbox = '';
        this.selectOptions = [];
        return;
      }

      // clear selected options
      this.selected = [];

      // check input factoryName correct
      var factoryNameList = this.factoryInfo.map(function (item) {
        return item.factory + '_' + item.factoryId;
      });
      var inputCorrect = factoryNameList.includes(this.searchInput);
      if (!inputCorrect) {
        return this.$swal('請正確輸入案場(含編號)');
      }

      // list selectOptions
      var match = this.searchInput.match(/^(.*?)_[^_]+$/); // 抓取最後一個底線前的字串
      var selectedFactoryName = match === null || match === void 0 ? void 0 : match[1];
      var _this$factoryInfo$fil = this.factoryInfo.filter(function (item) {
          return item.factory === selectedFactoryName;
        }),
        _this$factoryInfo$fil2 = _slicedToArray(_this$factoryInfo$fil, 1),
        selectedFactoryData = _this$factoryInfo$fil2[0];
      var irrList = (_selectedFactoryData$ = selectedFactoryData.irrPct) !== null && _selectedFactoryData$ !== void 0 && _selectedFactoryData$.length ? selectedFactoryData.irrPct.map(function (_, idx) {
        return "IRR_".concat(idx + 1);
      }) : ["IRR_1"];
      var invList = selectedFactoryData.invBrand.map(function (_, idx) {
        return "INV_".concat(idx + 1);
      });
      this.selectOptions = ['HV-meter', 'LV-meter'].concat(_toConsumableArray(irrList), ['PVTemp', 'ENVTemp', 'Anemometer'], _toConsumableArray(invList));
    }
  }),
  mounted: function mounted() {
    var _this2 = this;
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (_this2.factoryInfo.length) {
                _context2.next = 3;
                break;
              }
              _context2.next = 3;
              return _this2.asyncInfo();
            case 3:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  }
};